import React from 'react';

class CheckboxFilter extends React.Component {
    constructor(props) {
      super(props);
      this.filter = this.filter.bind(this);
      this.isFiltered = this.isFiltered.bind(this);
    }

    componentWillMount(){
        this.props.filterHandler({ callback: this.isFiltered });
    }
  
    filter(event) {
      if (this.refs.okCheckbox.checked === false) {
          // all checkboxes are checked means we want to remove the filter for this column
          this.props.filterHandler();
      } else {
          this.props.filterHandler({ callback: this.isFiltered });
      }
    }

    isFiltered(targetValue) {
        if (targetValue === 'active') {
        return (this.refs.okCheckbox.checked);
        }
    }
  
    render() {
      return (
        <div style={{alignItems:'center', display:'inline-flex', marginTop:'4px', maxHeight:"8px"}}>
          <input style={{marginBottom:'14px'}} ref='okCheckbox' type='checkbox' className='filter' onChange={ this.filter } defaultChecked={ true } /><label style={{marginBottom:'8px', paddingLeft:'5px'}}>{ this.props.textOK }</label>
        </div>
      );
    }
  }
  
  CheckboxFilter.propTypes = {
    filterHandler: React.PropTypes.func.isRequired,
    textOK: React.PropTypes.string,
  };
  
  CheckboxFilter.defaultProps = {
    textOK: 'OK',
  };

export default CheckboxFilter